import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';

const mutationImportData = (onSuccess, onError) => {
    return {
        mutationFn: ({ importApi, file, pathParams, extra }) => {
            return client.post(replaceParameters(importApi, pathParams), { file, extra });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: (data) => {
            onSuccess(data.data);
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationImportData;